import { Image, Text, View } from "react-native";
import { useBlocksUser } from "@/src/services/users.blocks.api";

type BlocksAvatarProps = Readonly<{
  userId?: string;
  // Shown while the Blocks lookup resolves or if the user has no image.
  fallbackImageUrl?: string | null;
  // Used for the initials placeholder when no image is available.
  firstName?: string;
  lastName?: string;
  name?: string;
  size?: number;
  className?: string;
}>;

const getInitials = (firstName?: string, lastName?: string, name?: string) => {
  const first = (firstName ?? "").trim();
  const last = (lastName ?? "").trim();
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();
  const source = (first || last || name || "").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
};

const BlocksAvatar = ({
  userId,
  fallbackImageUrl,
  firstName,
  lastName,
  name,
  size = 32,
  className,
}: BlocksAvatarProps) => {
  const { data: user } = useBlocksUser(userId);
  const uri = user?.profileImageUrl ?? fallbackImageUrl ?? null;

  if (uri) {
    return (
      <Image
        source={{ uri }}
        style={{ width: size, height: size, borderRadius: size / 2 }}
        className={className}
      />
    );
  }

  const initials = getInitials(
    firstName ?? user?.firstName,
    lastName ?? user?.lastName,
    name,
  );

  return (
    <View
      style={{ width: size, height: size, borderRadius: size / 2 }}
      className={`bg-primary items-center justify-center ${className ?? ""}`}
    >
      <Text
        className="text-white font-semibold"
        style={{ fontSize: Math.max(10, Math.round(size * 0.4)) }}
      >
        {initials}
      </Text>
    </View>
  );
};

export default BlocksAvatar;
